module.exports = __webpack_public_path__ + "static/media/cities.bedd9dd3.svg";